import "./index.scss";
import "../../assets/styles/main.scss";

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { setOpenedModal, setOpenedModalStart } from "../../redux/actions";
import CloseButton from "../../components/common/CloseButton";
import Countdown from "../../components/Countdown";
import ContactsForm from "../../components/BlackForm/Contacts";
import SupportAppArtForm from "../../components/BlackForm/SupportAppArt";
import AppSupportForm from "../../components/BlackForm/SupportApp";
import Success from "../../components/Countdown/Success";
import SelectFiles from "../../components/common/SelectFiles";
import SignIn from "../../components/BlackForm/SignIn";
import { nav_to_details, pageLoad } from "../../functions/route";

const Modal = ({
  openedModal,
  setOpenedModalStart,
  openedModalStart,
  setOpenedModal,
}) => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [isContactFormSubmitted, setIsContactFormSubmitted] = useState(false);
  const [isAppSupportSubmitted, setIsAppSupportSubmitted] = useState(false);
  const [isAppSupportArtSubmitted, setIsAppSupportArtSubmitted] = useState(false);
  const [isSignInSubmitted, setIsSignInSubmitted] = useState(false);
  const [isSelectFilesOpened, setSelectFilesOpened] = useState(false);

  useEffect(() => {
    if (openedModal) {
      document.getElementsByTagName("html")[0].style.overflowY = "hidden";
    } else {
      document.getElementsByTagName("html")[0].style.overflowY = "scroll";
    }
  }, [openedModal]);

  const closeModal = () => {
    setOpenedModalStart("");
    nav_to_details();

    setOpenedModal("");
    setIsSuccess(false);
    setIsContactFormSubmitted(false);
    setIsAppSupportSubmitted(false);
    setIsAppSupportArtSubmitted(false);
    setIsSignInSubmitted(false);
    setSelectFilesOpened(false);
  };

  return (
    <>
      {openedModal && openedModal !== "appSupportArt" && (
        <CloseButton
          classesButton={`modal__close`}
          classes={`modal__close-icon`}
          closeAction={closeModal}
        />
      )}

      <div
        className={
          openedModalStart
            ? "modal modal--show_start"
            : `modal ${openedModal && "modal--show"}`
        }
      >
        {openedModal &&
        !["contactus", "appSupport", "appSupportArt", "signIn"].includes(openedModal) ? (
          <Countdown
            isSuccess={isSuccess}
            setIsSuccess={setIsSuccess}
            type={openedModal}
            isShown={
              openedModal &&
              !["contactus", "appSupport", "signIn"].includes(openedModal)
            }
          />
        ) : openedModal === "contactus" ? (
          <ContactsForm
            isShown={openedModal === "contactus"}
            setIsContactFormSubmitted={setIsContactFormSubmitted}
          />
        ) : openedModal === "signIn" ? (
          <SignIn
            isShown={openedModal === "signIn"}
            setIsSignInSubmitted={setIsSignInSubmitted}
            setSelectFilesOpened={setSelectFilesOpened}
          />
        ) : openedModal === "appSupport" ? (
          <AppSupportForm
            isShown={openedModal === "appSupport"}
            setIsAppSupportSubmitted={setIsAppSupportSubmitted}
          />
        ) : openedModal === "appSupportArt" ? (
          <SupportAppArtForm
            isShown={openedModal === "appSupportArt"}
            setIsAppSupportArtSubmitted={setIsAppSupportArtSubmitted}
          />
        ) : null}
        <SelectFiles
          isOpen={isSelectFilesOpened}
          setIsSignInSubmitted={setIsSignInSubmitted}
        />
      </div>
      <Success
        isOpen={
          isSuccess ||
          isContactFormSubmitted ||
          isAppSupportSubmitted ||
          isAppSupportArtSubmitted ||
          isSignInSubmitted
        }
        type={openedModal}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  openedModal: state.openedModal,
  openedModalStart: state.openedModalStart,
});

const mapDispatchToProps = (dispatch) => ({
  setOpenedModalStart: (value) => dispatch(setOpenedModalStart(value)),
  setOpenedModal: (value) => dispatch(setOpenedModal(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
